import { SectionTitle } from "../../components/SectionTitle";
import { TablePlot } from "../../components/TablePlots";
import { CardLayout } from "../../components/CardLayout";
import { formatNumberForDisplay } from "@/utils/numberFormatting";

export default function DemoSubjectsSection({ data }: { data: any }) {
  return (
    <div>
      <SectionTitle title="SUBJECTS" />
      <div className="grid lg:grid-cols-9 sm:grid-cols-2 grid-cols-1  gap-4 ">
        <div className="col-span-9 ">
          <div className="grid lg:grid-cols-10 sm:grid-cols-4 grid-cols-1 gap-4 h-full">
            <div className="lg:col-span-2 sm:col-span-4 col-span-1">
              <div className="grid lg:grid-cols-1 sm:grid-cols-2 grid-cols-1 gap-4 h-full">
                <CardLayout
                  title="Sex"
                  subtitle="All subjects at all sites"
                  fullHeight={true}
                >
                  <div className="p-4">
                    <TablePlot
                      data={[data.enrollment_data.sex]}
                      mode="distribution"
                    />
                  </div>
                </CardLayout>
                <CardLayout
                  title="Indication Stage"
                  subtitle="All subjects at all sites"
                  fullHeight={true}
                >
                  <div className="p-4">
                    <TablePlot
                      data={[data.enrollment_data.indication]}
                      mode="distribution"
                    />
                  </div>
                </CardLayout>
              </div>
            </div>
            <div className="lg:col-span-3 sm:col-span-2 col-span-1">
              <CardLayout
                title="Race"
                subtitle="All subjects at all sites"
                fullHeight={true}
              >
                <div className="p-4 h-full">
                  <TablePlot
                    data={[data.enrollment_data.race]}
                    mode="distribution"
                    sorted={true}
                  />
                </div>
              </CardLayout>
            </div>
            <div className="sm:col-span-2 col-span-1 h-full">
              <CardLayout
                title="Current Age"
                fullHeight={true}
                subtitle="All subjects at all sites"
              >
                <div className="p-4 h-full">
                  <table className="w-full h-full">
                    <tbody>
                      {Object.entries(data.current_age_stats).map(
                        ([key, value]: [string, any]) => (
                          <tr key={key}>
                            <td className="text-[14px] text-[#2B4752]">
                              {key}
                            </td>
                            <td className="text-[14px] text-end font-semibold text-[#2B4752]">
                              {key === "Sample Size (n)"
                                ? value
                                : formatNumberForDisplay(value)}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              </CardLayout>
            </div>
            <div className="lg:col-span-3 sm:col-span-2 col-span-1 h-full">
              <CardLayout
                title="Cumulative Dose for Completed Subjects"
                fullHeight={true}
                subtitle="All subjects at all sites"
              >
                <div className="p-4 h-full">
                  <TablePlot
                    data={[data.enrollment_data.cumulativeDose]}
                    mode="distribution"
                    sorted={true}
                  />
                </div>
              </CardLayout>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
